const currentYear = new Date().getFullYear();
const yearsArr = Array.from({ length: 100 }, (_, i) => currentYear - i);
const getLastOneHundredYears = yearsArr.map((year) => ({
  key: year,
  label: year.toString(),
  value: year,
}));

export default getLastOneHundredYears;
